import { render, staticRenderFns } from "./ed-portal-info-section-course-name.vue?vue&type=template&id=5c05fd2f&scoped=true&"
import script from "./ed-portal-info-section-course-name.ts?vue&type=script&lang=js&"
export * from "./ed-portal-info-section-course-name.ts?vue&type=script&lang=js&"
import style0 from "./ed-portal-info-section-course-name.scss?vue&type=style&index=0&id=5c05fd2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c05fd2f",
  null
  
)

export default component.exports